exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input{font-size:14px;color:#fff;min-width:150px;border:2px solid #46a7fe;border-radius:8px;outline:unset;resize:none;background:transparent;min-height:44px;padding:5px;display:inline-block;vertical-align:top;cursor:text}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/styles/inputs.css
// module id = 229
// module chunks = 0